import { Group, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import classes from './PageHeader.module.scss';

interface PageHeaderProps {
  title: string;
  meta?: string;
  actions?: ReactNode;
}

export default function PageHeader({ title, meta, actions }: PageHeaderProps) {
  return (
    <header className={classes.pageHeader}>
      <Group gap="sm" wrap="wrap" className={classes.titleGroup}>
        <Title order={1} className={classes.title}>
          {title}
        </Title>
        {meta && (
          <Text component="span" className={classes.meta}>
            {meta}
          </Text>
        )}
      </Group>
      {actions && <div className={classes.actions}>{actions}</div>}
    </header>
  );
}
